export function googleMap() {
    return new Promise(function (resolve, reject) {
        window.onload = function () {
            resolve(google)
        }
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "";//"https://ditu.google.cn/maps/api/js?sensor=true&key=AIzaSyBFWHdjksN7NVDtMEptcscTJ4MxvsgmjOE";
        script.onerror = reject;
        document.head.appendChild(script);
    })
}




// WEBPACK FOOTER //
// ./src/components/googleMap.js